import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><path d=\"M946.56 504.96L534.528 93.44a31.936 31.936 0 0 0-45.184 0L77.44 504.96a64 64 0 0 0 45.184 109.312h43.392v293.76a32 32 0 0 0 32 32H448v-224h112v224h265.92a32 32 0 0 0 32-32v-293.76h43.392a64.064 64.064 0 0 0 45.184-109.312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol